import { Component, Input, ViewChild, Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import * as numberFormatting from '../../libs/jsCalc/numberFormatting';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import { ChartDefaults } from './chartdefaults';

@Component({
    selector: 'basicline',
    template: require('./basicline.html')
})

export class BasicLineComponent implements OnDestroy, OnInit {
    @Input() data:any;
    @Input() categorylabels:Array<any>;
    @Input() serieslabels:Array<any>;
    @Input() legendlabels:Array<any>;
    @Input() year:string = "";
    @Input() chartoptions:any = "";
    @Input() min:number;
    @Input() max:number;
    @Input() yAxisTickInterval:number;
    @Input() numberformat:string = "";
    @Input() charttitle:string = "";
    @Input() width:number;
    @Input() height:number;
    @Input() linewidth = "";
    @Input() charttitleoffsety:number = -35;
    @Input() chartmargintop:number = 0;
    @Input() legendalign = "center";
    @Input() legendverticalalign = "bottom";
    @Input() legendlayout = "horizontal";

    private chart:any = null;
    private observer:any;
    private gaugeVal:number = 0;
    private $elementRef:any = ElementRef;
    private el:ElementRef = null;
    private localDataArray = [];
    private localCategoryLabelsArray = [];
    private localSeriesLabelsArray = [];
    
    private chartData: any; 

    constructor(el: ElementRef, private chartDefaults: ChartDefaults) {
        let self = this;
        self.el = el;
        // extend highcharts with highcharts-more
        HighchartsMore(Highcharts);
    }

    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
        //this.observer.unsubscribe();
    }

    ngOnInit() {
        this.renderGraph();
        //this.processChartInputs();
    }

    renderGraph() {
        var opt = {}, self = this;

        this.chartData = this.chartDefaults.getBasicLineChartDefaults();

        //self.chartData.chart.width = "900";
        //self.chartData.chart.height = "500";
        self.chartData.chart.renderTo = self.el.nativeElement.childNodes[0];

        if (this.legendlabels === undefined || this.legendlabels.length === 0) {
            this.legendlabels = this.serieslabels;
        }
        if (this.min != undefined) {
            self.chartData.yAxis.min = this.min;
        }
        if (this.max != undefined) {
            self.chartData.yAxis.max = this.max;
        }
        if (this.yAxisTickInterval != undefined) {
            self.chartData.yAxis.tickInterval = this.yAxisTickInterval;
        }
        self.chartData.legend.align = this.legendalign;
        self.chartData.legend.verticalAlign = this.legendverticalalign;
        self.chartData.legend.layout = this.legendlayout;

        if (this.charttitle != "") {
            self.chartData.title.text = this.charttitle;
        }

        for (let i = 0; i < self.categorylabels.length; i++) {
            self.chartData.xAxis.categories[i] = self.categorylabels[i];
        }

        for (let i = 0; i < self.serieslabels.length; i++) {
            let localDataArray = [];
            let seriesName = self.serieslabels[i];
            let legendName = self.legendlabels[i];
            for (let j = 0; j < self.data[seriesName].length; j++) {
                localDataArray.push(Number(self.data[seriesName][j]));
            }

            self.chartData.series.push ({
                name: legendName,
                data: localDataArray,
                lineWidth: 1
            });
        }
        
        if (self.chartoptions !== "")
            self.chartoptions = JSON.parse(self.chartoptions);

        _.merge(opt, self.chartData, self.chartoptions);

        self.chart = new Highcharts.Chart(opt);
    }

    reRenderGraph(data: any, serieslabels: Array<any>, legendlabels: Array<any>, categorylabels:Array<any>, chartoptions:any) {
        this.data = data;
        this.serieslabels = serieslabels;
        this.legendlabels = legendlabels;
        this.categorylabels = categorylabels;
        this.chartoptions = chartoptions;
        this.renderGraph();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/charts/basicline.ts